export default "__VITE_ASSET__PZJSnUDa__"